<template>
    <div class="o-announcements">
        <div
            v-for="(announcement, announcementIdx) in announcements"
            :key="announcementIdx"
            class="l-row o-announcements__announcement"
        >
            <div class="l-row__column o-announcements__announcementContent">
                <component
                    v-if="announcement && announcement.component"
                    v-bind:is="announcement.component"
                />
            </div>
            <div class="l-row__column o-announcements__announcementClose">
                <a-button
                    v-if="!announcement.noClosable"
                    class="o-announcements__announcementCloseBtn"
                    icon="Close"
                    @click="onAnnouncementRemove(announcement.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Announcement',
    computed: {
        announcements() {
            return this.$store.getters['announcements/getAnnouncements']
        }
    },
    methods: {
        onAnnouncementRemove(announcementId) {
            this.$store.dispatch(
                'announcements/removeAnnouncement',
                announcementId
            )
        }
    }
}
</script>
